import { useNavigate } from "@solidjs/router";
import Text from "../Text";
import { useTranslation } from "../../hooks/useTranslation";
import { useActiveBot } from "../../state/activeBot";
import { type StorageInfo } from "../../services/inventoryApi";
import styles from "./SellChamberNote.module.css";

export default function SellChamberNote(props: { storage: StorageInfo }) {
  const { t } = useTranslation();
  const { setBot } = useActiveBot();
  const navigate = useNavigate();

  function openSellbotSettings() {
    setBot(props.storage.sellChamberBotId!);
    navigate("/sellbot/config");
  }

  return (
    <div class={`h ${styles.note}`}>
      <i class="fa-solid fa-store" aria-hidden="true" />
      <span class={styles.text}>{t("STORAGE_SELL_CHAMBER_DISCOVERY_LOCKED", props.storage.sellChamberBotName)}</span>
      <button class="btn btn-secondary btn-sm" onClick={openSellbotSettings}>
        <Text val="STORAGE_SELL_CHAMBER_OPEN_SELLBOT" />
      </button>
    </div>
  );
}
